import React from "react";
import { connect } from "react-redux";

import cx from "classnames";

import { Col, Dropdown, Row } from "react-bootstrap";
import SlidePaneView from "../../../components/SlidePaneView"
import InfiniteScroll from "../../../components/InfinteScroll";

import styles from '../reports.module.scss';
import ContactDetailsSlideview from "../../../components/Contacts/ContactDetails/ContactDetailsSlideview.jsx";
import { prepareRequest } from "../../../services/report.service"
import userRoleService from "src/services/userRoles.service"

import isEqual from "is-equal";
import _ from "lodash";
import Download from "../../../components/Download"
import { intializeDownloadReport, resetReportDownload } from "../../../redux/actions/reports.jsx";
import { localizedStrings } from '../../../../localization/index'
import CustomTooltip from "src/components/tooltip";

class EntityReport extends React.Component {
  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;

    this.state = {
      request: null,
      viewMore: false,
      sortBy: { name: this.localizedTabsCommons.views, value: "views" },
    };

    this.handleViewMoreClicked = this.handleViewMoreClicked.bind(this);
    this.handleSortSelection = this.handleSortSelection.bind(this);
    this.localizedDiscovery = this.localizedReport.tabs.discovery;
  }

  componentDidMount() {
    this.loadReport(this.props.request, 0, 5);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.request, nextProps.request)) {
      this.loadReport(nextProps.request, 0, 5);

      this.setState({ sortBy: { name: this.localizedTabsCommons.views, value: "views" } });
    }
  }

  loadReport(request, page, limit) {
    if (!request) {
      return;
    }

    const processedRequest = prepareRequest(
      request,
      this.props.supportedEntities
    );
    if (!_.isEqual(this.state.request, processedRequest)) {
      this.setState(
        {
          request: processedRequest,
        },
        () => {
          this.props.fetchData(processedRequest, page, limit);
        }
      );
    }
  }

  handleViewMoreClicked() {
    this.setState({
      viewMore: true,
    });
  }

  handleSortSelection(field) {
    document.body.click(); //Close popover

    var newRequest = {
      ...this.state.request,
      sortBy: field.value,
    };

    this.setState(
      {
        sortBy: field,
        request: newRequest,
      },
      () => {
        this.props.fetchData(newRequest, 0, 5);
      }
    );
  }

  renderSortOption() {
    var fields = [
      {
        name: this.localizedTabsCommons.views,
        value: "views",
      },
      {
        name: this.localizedTabsCommons.avg_time,
        value: "avgTime",
      },
      {
        name: this.localizedTabsCommons.downloads,
        value: "downloads",
      },
    ];

    return <Dropdown>
      <Dropdown.Toggle className={cx(styles.dropdownButton,styles.viewsDropdown)} as={'button'}>
        <img className={styles.filterList} />
        <span className={styles.type}>{this.state.sortBy.name}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropdownMenuContainer} popperConfig={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 6],
            },
          },
        ],
      }}>
        {fields.map((item, index) => {
          var active = isEqual(this.state.sortBy.value, item.value);
          return <Dropdown.Item key={index}
            className={cx(styles.dropdownItem, { [styles.active]: active })}
            onClick={() => this.handleSortSelection(item)}>
            {item.name}
          </Dropdown.Item>
        })}
      </Dropdown.Menu>
    </Dropdown>
  }

  render() {
    var count = (_.get(this.props.data, "items") || []).length;
    var pages = _.get(this.props.data, "pagination.totalPages");
    var empty = count == 0;
    var hasMore = count > 5 || pages > 1;

    let fileName = "Reports.csv",
      headers = [];
    if (this.props.downloadProperties) {
      if (this.props.downloadProperties.fileName) {
        fileName = this.props.downloadProperties.fileName;
      }

      if (this.props.downloadProperties.headers) {
        headers = this.props.downloadProperties.headers;
      }
    }

    return (
      <div className={cx(styles.entityReport, this.props.className, {
        [styles.withSortIcon] : this.props.canSortReport
      })}>
        {this.props.canSortReport && <div className={styles.filterIconContainer}>
         { this.renderSortOption()}
        </div>}
        <div className={styles.icon}>
          <i className={this.props.icon} />
        </div>
        <h5 className={styles.title}>{this.props.title} <span className={styles.entityReportTooltip}>

          <CustomTooltip content={this.props.tooltipText} placement="top">
            <i className="paperflite-info"></i>
          </CustomTooltip>

        </span></h5>



        {this.props.loading && empty && (
          <div className={styles.loading}>{this.localizedCommonLoading.report}...</div>
        )}

        {!this.props.loading && empty && (
          <div className={styles.loading}>{this.localizedTabsCommons.no_data}</div>
        )}

        {(!this.props.loading || !empty) && this.renderReport()}

        {hasMore && (

          <span className={styles.viewMoreButton} onClick={this.handleViewMoreClicked}>
            <i className="paperflite-right-arrow"/> view more
          </span>

        )}

        {!hasMore && !this.props.loading && (count > 0) && (
          <button
            className={styles.downloadButton}
          >
            {userRoleService.canDownloadReport() && (
              <Download
                id={this.props.id}
                request={this.props.request}
                fileName={fileName}
                headers={headers}
                fetchData={this.props.downloadReport}
                resetReportDownload={this.props.resetReportDownload}
                pagination={this.props.download ? this.props.data.pagination : {}}
                supportedEntities={this.props.supportedEntities}
                downloaded={this.props.download ? this.props.download.downloaded : false}
                downloading={this.props.download ? this.props.download.downloading : false}
                error={this.props.download ? this.props.download.error : null}
                data={this.props.download ? this.props.download.items : []}
                className={styles.downloadButton}
              />

            )}
          </button>
        )}

        <EntityReportPopup
          show={this.state.viewMore}
          id={this.props.id}
          title={this.props.title}
          icon={this.props.icon}
          className={this.props.className}
          {...this.props.grid}
          request={this.state.request}
          data={this.props.data}
          fetchData={this.props.fetchData}
          downloadReport={
            userRoleService.canDownloadReport() && this.props.downloadReport
          }
          downloadProperties={this.props.downloadProperties}
          onClose={() => {
            this.setState({ viewMore: false });
          }}
          tooltipText={this.props.tooltipText}
        />
      </div>
    );
  }

  renderReport() {
    if (!this.props.data || !this.props.data.items) {
      return false;
    }

    const items = _.take(this.props.data.items, 5).map((item, index) => {
      return React.createElement(
        this.props.list.renderer,
        {
          id: this.props.id,
          key: index,
          index: index,
          item: item,
          showDetail: this.props.showContactsView
        }
      );
    });

    return <div className={styles.list}>{items}</div>;
  }
}

EntityReport.defaultProps = {
  title: "",
  icon: "",
};

class EntityReportPopupView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedContact: null,
      download: this.props.download,
    };

    this.showContactsView = this.showContactsView.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show) {
      nextProps.fetchData(this.props.request, 0, 20);
    }

    this.setState({ download: nextProps.download });
  }

  showContactsView(recipientContact) {
    this.setState({
      selectedContact: recipientContact,
    });
  }

  handleScroll() {
    const currentPage = _.get(this.props.data, "pagination.currentPage");
    const nextPage = currentPage + 1;
    const totalPages = _.get(this.props.data, "pagination.totalPages");

    if (nextPage > totalPages) {
      return;
    }

    this.props.fetchData(this.props.request, nextPage, 20);
  }

  hasMoreItems() {
    const currentPage = _.get(this.props.data, "pagination.currentPage");
    const nextPage = currentPage + 1;
    const totalPages = _.get(this.props.data, "pagination.totalPages");

    return nextPage < totalPages;
  }

  render() {

    let fileName = "Reports.csv",
      headers = [];
    if (this.props.downloadProperties) {
      if (this.props.downloadProperties.fileName) {
        fileName = this.props.downloadProperties.fileName;
      }

      if (this.props.downloadProperties.headers) {
        headers = this.props.downloadProperties.headers;
      }
    }

    return (
      <div>
        <SlidePaneView
          width="100vw"
          direction="left"
          className={cx(
            styles.entityReport,
            styles.popup,
            this.props.className
          )}
          show={this.props.show}
        >
          <div className={styles.body}>
            <button className={styles.close} onClick={this.props.onClose}>
              <i className="paperflite-close"></i>
            </button>
            <div className={styles.header}>
              <div className={styles.icon}>
                <i className={this.props.icon} />
              </div>
              <h5 className={styles.title}>
                <span>{this.props.title}</span>
                <span className={styles.modalTooltipContainer}>
                  <CustomTooltip content={this.props.tooltipText} placement="right">
                    <i className="paperflite-info"></i>
                  </CustomTooltip>
                </span></h5>
              <div className={styles.downloadContainer}>
                {userRoleService.canDownloadReport() && (
                  <Download
                    id={this.props.id}
                    request={this.props.request}
                    fileName={fileName}
                    headers={headers}
                    fetchData={this.props.downloadReport}
                    resetReportDownload={this.props.resetReportDownload}
                    pagination={this.props.download ? this.props.download.pagination : {}}
                    downloaded={this.props.download ? this.props.download.downloaded : false}
                    downloading={this.props.download ? _.get(this.props.download, "downloading") : false}
                    error={this.props.download ? this.props.download.error : null}
                    data={this.props.download ? this.props.download.items : []}
                    className={styles.downloadButton}
                  />

                )}
              </div>
            </div>
            <div className={styles.table}>

              {this.renderColumns(this.props.columns)}
              <div className={cx(styles.scroll, `styles.${this.props.id}`)}>
                <InfiniteScroll
                  loading={_.get(this.props.data, "loading")}
                  hasMore={this.hasMoreItems()}
                  loadMore={() => {
                    this.handleScroll();
                  }}
                >
                  {this.renderReport()}
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </SlidePaneView>
        <ContactDetailsSlideview
          onClose={() => this.setState({ selectedContact: null })}
          selectedContact={this.state.selectedContact}
        />
      </div>
    );
  }

  renderColumns(columns) {
    if (!columns) {
      return false;
    }

    const items = columns.map((column, index) => {
      return (
        <Col key={index} className={styles.column} md={column.width}>
          {column.title}
        </Col>
      );
    });

    return <Row className={cx(styles.row, styles.header)}>{items}</Row>;
  }

  renderReport() {
    if (!this.props.data || !this.props.data.items) {
      return false;
    }
    const items = this.props.data.items.map((item, index) => {
      return React.createElement(this.props.renderer, {
        id: this.props.id,
        key: index,
        index: index,
        item: item,
        showDetail: this.showContactsView,
      });
    });

    return items;
  }
}

EntityReportPopupView.defaultProps = {
  fetchData: (request, page, limit) => {
    console.log(`fetch data page ${page} & limit ${limit}`);
  },
};

const EntityReportPopup = connect(
  (state, ownProps) => {
    return {
      download: state.legacyRootReducer.reports.download,
    };
  },
  (dispatch) => {
    return {
      downloadReport: (id, filter, page, limit) => {
        return dispatch(intializeDownloadReport(id, filter, page, limit));
      },
      resetReportDownload: () => dispatch(resetReportDownload()),
    };
  }
)(EntityReportPopupView);

EntityReport.Popup = EntityReportPopup;

export default EntityReport;
